import { lazyGettext } from '@eb/lazy-gettext';
import { PACKAGE_ONE, PACKAGE_THREE, PACKAGE_TWO } from '../../constants/main';
import { STYLE_FILL, STYLE_NEUTRAL } from '@eb/eds-button';

export default {
    [PACKAGE_ONE]: {
        mainHeader: {
            primaryCTA: lazyGettext('Upgrade'),
            CTAStyle: STYLE_FILL,
        },
        bottomBanner: {
            CTA: lazyGettext('Upgrade'),
            CTAStyle: STYLE_NEUTRAL,
        },
    },
    [PACKAGE_TWO]: {
        mainHeader: {
            primaryCTA: lazyGettext('Your Current Package'),
            CTAStyle: null,
        },
        bottomBanner: {
            CTA: lazyGettext('Your Current Package'),
            CTAStyle: null,
        },
    },
    [PACKAGE_THREE]: {
        mainHeader: {
            primaryCTA: lazyGettext('Downgrade'),
            CTAStyle: STYLE_NEUTRAL,
        },
        bottomBanner: {
            CTA: lazyGettext('Downgrade'),
            CTAStyle: STYLE_NEUTRAL,
        },
    },
};
